import { carePlanRequestsTyped } from "@/api/(requests)/carePlanTyped";
import type { PatientStrengthsResponse } from "@/core/types";

export async function getStrengths(patientId: string): Promise<PatientStrengthsResponse> {
  return carePlanRequestsTyped.get_patient_strengths({
    context: { showLoader: false },
    patientId,
  });
}
